import React from 'react'
import Link from '@components/ui/link'
import Authentication, {
	AuthenticationType
} from '@components/auth/Authentication'

type Props = {
	text: string | JSX.Element
	className?: string
}

export const LoginButton = ({ className, text }: Props) => {
	const { authenticationSignin }: AuthenticationType = Authentication()

	return (
		<React.Fragment>
			<Link
				className={className}
				to="#"
				onClick={authenticationSignin}
				key="loginRedirect"
				rel="noopener noreferrer"
				data-tracking-type="cta"
			>
				{text}
			</Link>
		</React.Fragment>
	)
}
